<template>
  <VForms
    v-if="profile"
    :initial-values="profile"
    :validation-schema="validations"
    @submit="handleSubmit"
  >
    <template slot-scope="props">
      <form
        class="profile-form"
        @submit.prevent="props.handleSubmit"
        @reset.prevent="props.handleReset"
      >
        <v-container
          grid-list-md
          align-center
          fill-height
        >
          <v-layout column>
            <v-layout
              fill-height
              align-start
            >
              <ProfileFormFields :form="props" />
            </v-layout>
            <StepperButtons
              :change-step="changeStep"
              :active="active"
              :number-of-steps="3"
              :form="props"
            />
          </v-layout>
        </v-container>
      </form>
    </template>
  </VForms>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Form as VForms } from '@v-forms/core'
import {
  required,
  helpers,
} from 'vuelidate/lib/validators'
import { PROFILE_KEY, NICKNAME_KEY, ACTION_SAVE_PROFILE } from '../../../store/types/profile.types'
import ProfileFormFields from '../../profile/ProfileFormFields'
import StepperButtons from '../StepperButtons'

const phone = helpers.regex('phone', /^(\(?\+?[0-9]*\)?)?[0-9_\- ()]*$/)

export default {
  name: 'ProfileStep',
  components: {
    StepperButtons,
    VForms,
    ProfileFormFields,
  },
  props: {
    active: {
      type: Number,
      required: true,
    },
    changeStep: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      validations: {
        name: { required },
        surname: { required },
        street: { required },
        city: { required },
        zipCode: { required },
        country: { required },
        phone: { required, phone },
      },
    }
  },
  computed: {
    ...mapState({
      profile: state => state.profile[PROFILE_KEY],
      nickname: state => state.profile[NICKNAME_KEY],
    }),
  },
  methods: {
    handleSubmit(values, actions) {
      const profile = Object.assign(values, { nickname: this.nickname })
      const payload = { profile, showAlert: false }
      this.saveProfile(payload)
      actions.setSubmitting(false)
      this.changeStep(this.active + 1)
    },
    ...mapActions({
      saveProfile: ACTION_SAVE_PROFILE,
    }),
  },
}
</script>

<style lang="stylus" scoped>
.profile-form {
  height: 100%
}
</style>
